{#if (marks === undefined || index >= marks.length)}
  {text}

{:elseif marks[index].type === 'bold'}
  <strong>
    <svelte:self {marks} {text} index={index + 1} />
  </strong>

{:elseif marks[index].type === 'underline'}
  <u>
    <svelte:self {marks} {text} index={index + 1} />
  </u>

{:elseif marks[index].type === 'italic'}
  <em>
    <svelte:self {marks} {text} index={index + 1} />
  </em>

{:elseif marks[index].type === 'strikethrough'}
  <strike>
    <svelte:self {marks} {text} index={index + 1} />
  </strike>
{:else}
  {text}

{/if}
